export function getStrArrParam(params: string[]): string {
  return params.map(encodeURIComponent).join(',');
}
